module.exports = __webpack_public_path__ + "mobile/img/img_share_prompt.2295365b.png";